@if (hierarchicalProducts.length > 0) {
  <div class="products-hierarchy">
    @for (product of hierarchicalProducts; track product.productId) {
      <ng-container
        *ngTemplateOutlet="
          productTemplate;
          context: { $implicit: product, depth: 0, oldValue: false }
        "
      />
    }
  </div>
}

@if (hasComparisonDiff && comparisonHierarchicalProducts.length > 0) {
  <div class="products-hierarchy mt-8">
    @for (product of comparisonHierarchicalProducts; track product.productId) {
      <ng-container
        *ngTemplateOutlet="
          productTemplate;
          context: { $implicit: product, depth: 0, oldValue: true }
        "
      />
    }
  </div>
}

<ng-template
  #productTemplate
  let-product
  let-depth="depth"
  let-oldValue="oldValue"
>
  @if (shouldDisplayProduct(product)) {
    <div class="product-item" [style.padding-left.px]="depth * 16">
      <span
        class="product-name"
        [ngClass]="{
          'new-lead-value': hasComparisonDiff && !oldValue,
          'old-lead-value': oldValue,
        }"
      >
        {{ getProductName(product) }}
      </span>
      @if (product.amount) {
        <span
          class="product-amount"
          [ngClass]="{
            'new-lead-value': hasComparisonDiff && !oldValue,
            'old-lead-value': oldValue,
          }"
        >
          {{ product.amount | currency: 'CHF' }}
        </span>
      }
    </div>
    @if (product.products && product.products.length > 0) {
      @for (child of product.products; track child.productId) {
        <ng-container
          *ngTemplateOutlet="
            productTemplate;
            context: { $implicit: child, depth: depth + 1, oldValue: oldValue }
          "
        />
      }
    }
  }
</ng-template>
